<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.toefl_detail") }}</h4>
          </div>
        </md-card-header>
        <md-card-content v-if="dataDetail.toefl.length">
          <chart :data-detail="dataDetail"></chart>

          <h6 class="title text-md font-medium normal-case my-5">
            {{ $t("smi_sri.total_tests_taken", { length: dataTable.length }) }}
          </h6>

          <p class="text-right text-red-600 text-xl">
            {{ $t("smi_sri.super_score") }}:
            <span class="font-medium">{{ dataDetail.super_score }}</span>
          </p>
          <md-table class="md-scrollbar">
            <md-table-row>
              <md-table-head>{{ $t("smi_sri.test_name") }}</md-table-head>
              <md-table-head>{{ $t("smi_sri.test_date") }}</md-table-head>
              <md-table-head>{{ $t("smi_sri.total_score") }}</md-table-head>
              <md-table-head>Listening</md-table-head>
              <md-table-head>Reading</md-table-head>
              <md-table-head>Writing</md-table-head>
              <md-table-head>Speaking</md-table-head>
            </md-table-row>

            <md-table-row
              v-for="(row, index) in dataTable"
              :key="row.test_name + index"
            >
              <md-table-cell>{{ row.test_name }}</md-table-cell>
              <md-table-cell>{{
                convertDateFromServer(row.test_date, "date")
              }}</md-table-cell>
              <md-table-cell>{{ row.total_score }}</md-table-cell>
              <md-table-cell>{{ row.listening }}</md-table-cell>
              <md-table-cell>{{ row.reading }}</md-table-cell>
              <md-table-cell>{{ row.speaking }}</md-table-cell>
              <md-table-cell>{{ row.writing }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-content v-else>
          <no-data-found></no-data-found>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import Chart from "./Chart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  components: { Chart },
  props: ["dataDetail"],
  data() {
    return {
      convertDateFromServer
    };
  },
  computed: {
    dataTable() {
      return this.dataDetail.toefl;
    }
  }
};
</script>
